// extracted by mini-css-extract-plugin
module.exports = {"menu":"sortingMenu_menu__nnejf"};